"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useIsTextClamped } from "@/lib/hooks/use-is-text-clamped";
import { cn } from "@/lib/utils";

// Time the pointer has to rest on the text before the full value shows up.
const FULL_TEXT_DELAY_MS = 1000;

// Single-line text that ellipsizes in a tight spot. Only when it actually is
// cut off does resting the pointer on it reveal the whole value in a tooltip;
// text that fits behaves like plain text. The parent has to let it shrink
// (`min-w-0` in a flex row), otherwise nothing ever truncates.
export const TruncatedText = ({
  text,
  className,
  delayMs = FULL_TEXT_DELAY_MS,
}: {
  text: string;
  className?: string;
  delayMs?: number;
}) => {
  const { ref, isClamped } = useIsTextClamped<HTMLSpanElement>(text);

  return (
    <TooltipProvider delayDuration={delayMs}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("block min-w-0 truncate", className)} ref={ref}>
            {text}
          </span>
        </TooltipTrigger>
        {/* Rendered only while the text is cut off, so the trigger keeps one
            DOM shape and the measuring ref stays attached either way. */}
        {isClamped && (
          <TooltipContent className="max-w-[340px] text-left">
            {text}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};
